import { render, staticRenderFns } from "./putzf.vue?vue&type=template&id=269fc496&scoped=true&"
import script from "./putzf.vue?vue&type=script&lang=js&"
export * from "./putzf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269fc496",
  null
  
)

export default component.exports